import { FeatureKind } from "@omni/types/api/product/bff/shared/featureKind.model";
import { CloudFeatureKind } from "@omni/types/api/product/cloud/shared/featureKind.model";
import { AlgoliaSearchFeature } from "@omni/types/api/search/algolia/product/shared/feature.model";
import { BffSearchFeature } from "@omni/types/api/search/bff/product/shared/feature.model";
import { ModelMapper } from "@omni/types/utils/modelMapper";

const fromCloudToBff: ModelMapper<CloudFeatureKind, FeatureKind> = (model) => {
    return {
        name: model.name,
        code: model.code,
        sortOrder: model.sortOrder
    } satisfies FeatureKind;
};

const fromAlgoliaSearchFeatureToBff: ModelMapper<
    AlgoliaSearchFeature,
    FeatureKind
> = (model) => {
    return {
        name: model.name,
        code: model.code,
        sortOrder: model.ranking
    } satisfies FeatureKind;
};

const fromBffSearchFeatureToBff: ModelMapper<BffSearchFeature, FeatureKind> = (
    model
) => {
    return {
        name: model.name,
        code: model.code,
        sortOrder: model.ranking
    } satisfies FeatureKind;
};

export const FeatureKindMapper = {
    fromCloudToBff: fromCloudToBff,
    fromAlgoliaSearchFeatureToBff: fromAlgoliaSearchFeatureToBff,
    fromBffSearchFeatureToBff: fromBffSearchFeatureToBff
};
